import { useWeb3React } from '@web3-react/core';
import { useMemo } from 'react';
import { config } from '../config';
export const useNativeTokenSymbol = () => {
    const { chainId } = useWeb3React();
    return useMemo(() => {
        return chainId ? config.network.nativeToken[chainId] : null;
    }, [chainId]);
};
